module.exports = __webpack_public_path__ + "static/media/6585-l-en.3fd584e2.png";